import React, {Component} from 'react';
import {Button, ListGroup} from 'react-bootstrap';
import JapanFlag from '../../../../../assets/img/japanFlag.jpg';
import {ProgressBar} from 'react-bootstrap';
import uuid from 'uuid';
import LatestOrdersList from './LatestOrdersList';
import '../../../HomeContent/PCBService/LatestOrders/ToDoList.css'
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import ArticlesRow from "../../../../Admin/Articles/ViewAllArticles/ArticlesRow/ArticlesRow";
import {FormattedMessage} from "react-intl";

class ToDoList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: LatestOrdersList.orderList.slice(0, 6)
        };
        this.setItems = this.setItems.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.getLatestOrders = this.getLatestOrders.bind(this);
        // this.getLastOrderList = this.getLastOrderList.bind(this);
    }

    setItems = () => {
        let state = this.state;

        // let i = Math.floor(Math.random() * LatestOrdersList.orderList.length);
        // let order = LatestOrdersList.orderList[i];
        // state.items.pop();
        // state.items.unshift(order);

        this.setState(state);
    };

    removeItem = (id) => {
        let state = this.state;
        state.items = state.items.filter((item) => id !== item.id);
        this.setState(state);
    };

    getLatestOrders = () => {

        axios.get(RESOURCE_BASE_URL + 'api/orders/latest')
            .then((res) => {
                this.setState({
                    items: res.data.orders,
                    orderCount: res.data.rowCount
                });
                // console.log(res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    };

    componentDidMount = () => {
        setInterval(this.setItems, 2500);
    };

    render() {
        // let setItems = this.setItems;
        // let removeItem = this.removeItem;
        let items = this.state.items;
        return (
            <tbody className="tbody-latest-order">
            {/*{items.map((item) => {*/}
            {/*return (*/}
            {/*<tr className="order-table-tr-height">*/}
            {/*<td><img src={JapanFlag} width={12}/> {item.orderNumber}</td>*/}
            {/*<td>{item.date}</td>*/}
            {/*<td className="text-amount">¥ {item.amount}</td>*/}
            {/*<td className="text-progress">*/}
            {/*<div className="col-md-3 no-padding">{item.progress}%</div>*/}
            {/*<div className="col-md-9 progressbar-div"><ProgressBar now ={item.progress}/></div>*/}
            {/*</td>*/}
            {/*</tr>*/}
            {/*);*/}
            {/*})}*/}


            <tr className="order-table-tr-height tr-1">
                <td>{items[0].date}</td>
                <td><img  className='flag-border-todolist' src={JapanFlag} width={12}/> {items[0].orderNumber}</td>
                <td className="text-amount">¥ {items[0].amount}</td>
                <td className="text-progress">
                    <div className="col-md-3 no-padding">{items[0].progress}%</div>
                    <div className="col-md-9 progressbar-div"><ProgressBar now={items[0].progress}/></div>
                </td>
            </tr>
            <tr className="order-table-tr-height tr-2">
                <td>{items[1].date}</td>
                <td><img  className='flag-border-todolist'  src={JapanFlag} width={12}/> {items[1].orderNumber}</td>
                <td className="text-amount">¥ {items[1].amount}</td>
                <td className="text-progress">
                    <div className="col-md-3 no-padding">{items[1].progress}%</div>
                    <div className="col-md-9 progressbar-div"><ProgressBar now={items[1].progress}/></div>
                </td>
            </tr>
            <tr className="order-table-tr-height tr-3">
                <td>{items[2].date}</td>
                <td><img   className='flag-border-todolist' src={JapanFlag} width={12}/> {items[2].orderNumber}</td>
                <td className="text-amount">¥ {items[2].amount}</td>
                <td className="text-progress">
                    <div className="col-md-3 no-padding">{items[2].progress}%</div>
                    <div className="col-md-9 progressbar-div"><ProgressBar now={items[2].progress}/></div>
                </td>
            </tr>
            <tr className="order-table-tr-height tr-4">
                <td>{items[3].date}</td>
                <td><img   className='flag-border-todolist' src={JapanFlag} width={12}/> {items[3].orderNumber}</td>
                <td className="text-amount">¥ {items[3].amount}</td>
                <td className="text-progress">
                    <div className="col-md-3 no-padding">{items[3].progress}%</div>
                    <div className="col-md-9 progressbar-div"><ProgressBar now={items[3].progress}/></div>
                </td>
            </tr>
            <tr className="order-table-tr-height tr-5">
                <td>{items[4].date}</td>
                <td><img   className='flag-border-todolist' src={JapanFlag} width={12}/> {items[4].orderNumber}</td>
                <td className="text-amount">¥ {items[4].amount}</td>
                <td className="text-progress">
                    <div className="col-md-3 no-padding">{items[4].progress}%</div>
                    <div className="col-md-9 progressbar-div"><ProgressBar now={items[4].progress}/></div>
                </td>
            </tr>
            <tr className="order-table-tr-height tr-6">
                <td>{items[5].date}</td>
                <td><img  className='flag-border-todolist'  src={JapanFlag} width={12}/> {items[5].orderNumber}</td>
                <td className="text-amount">¥ {items[5].amount}</td>
                <td className="text-progress">
                    <div className="col-md-3 no-padding">{items[5].progress}%</div>
                    <div className="col-md-9 progressbar-div"><ProgressBar now={items[5].progress}/></div>
                </td>
            </tr>


           {/* {this.state.items.length !== 0 ?
                this.state.items.map(order => {
                    return <tr className="order-table-tr-height tr-6">
                        <td>{order.createdDate.substring(1,5)}</td>
                        <td><img  className='flag-border-todolist'  src={JapanFlag} width={12}/> {order.batchNumber}</td>
                        <td className="text-amount">¥ {order.subTotal}</td>
                        <td className="text-progress">
                            <div className="col-md-3 no-padding">70%</div>
                            <div className="col-md-9 progressbar-div"><ProgressBar now={70}/></div>
                        </td>
                    </tr>
                }) : <div className="text-center"><FormattedMessage id="app.order.all.no-records"
                                                                    defaultMessage="No Records Found"
                                                                    description=""/></div>
            }
*/}




            </tbody>
        );
    }
}

export default ToDoList;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/PCBService/LatestOrders/ToDoList.js